import React from 'react';
import { Col, Row, Switch } from 'antd';
import { I18n } from '@aws-amplify/core';

import { IntegratedErgonomicToolDTO } from '@/components/ui/Inputs/types/response/customReport';
import { Description } from './styles';

interface PopulateSwitchProps {
	integratedTools: IntegratedErgonomicToolDTO[];
	disabled: boolean;
	populate: boolean;
	onSwitchChange: () => void;
}

export function PopulateSwitch({
	integratedTools,
	disabled,
	populate,
	onSwitchChange
}: Readonly<PopulateSwitchProps>): JSX.Element | null {
	if (!integratedTools?.length) {
		return null;
	}

	return (
		<Row align="bottom">
			<Col span={24} style={{ marginTop: '1rem' }}>
				<Description>{I18n.get('Populate using tool')}</Description>
			</Col>
			<Col span={24}>
				<Switch disabled={disabled} checked={populate} onChange={onSwitchChange} />
			</Col>
		</Row>
	);
}
